import { PlanTypes } from "../store/types";

// // // //

/**
 * getHasApiAccess
 * Returns true if the user has API access, false otherwise
 */
export function getHasApiAccess(plan: PlanTypes): boolean {
    return [
        PlanTypes.PREMIUM_ALL_ACCESS,
        PlanTypes.TRIAL_ALL_ACCESS,
        PlanTypes.PREMIUM_ACADEMIC,
    ].includes(plan);
}
